import { render, staticRenderFns } from "./asset-bar-collection.vue?vue&type=template&id=5b63ba83&"
import script from "./asset-bar-collection.vue?vue&type=script&lang=js&"
export * from "./asset-bar-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports